export default __webpack_public_path__ + "static/media/c008-board.aafd8fff.svg";